var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Component, Prop, Vue } from 'vue-property-decorator';
var SessionSidebar = /** @class */ (function (_super) {
    __extends(SessionSidebar, _super);
    function SessionSidebar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeTab = 'latest';
        return _this;
    }
    Object.defineProperty(SessionSidebar.prototype, "latestRows", {
        // The not-yet-saved "new conversation" placeholder is shown only in Latest,
        // pinned above the real rows, exactly like the server-backed entries will be
        // once fetchSessions() resolves and replaces it.
        get: function () {
            var rows = __spreadArray([], this.latest, true);
            if (this.pendingTitle) {
                rows.unshift({ id: null, title: this.pendingTitle, updated_at: '', is_favorite: false, pending: true });
            }
            return rows;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({ type: Array, required: true })
    ], SessionSidebar.prototype, "latest", void 0);
    __decorate([
        Prop({ type: Array, required: true })
    ], SessionSidebar.prototype, "favorites", void 0);
    __decorate([
        Prop({ default: null })
    ], SessionSidebar.prototype, "currentSessionId", void 0);
    __decorate([
        Prop({ default: null })
    ], SessionSidebar.prototype, "pendingTitle", void 0);
    __decorate([
        Prop({ type: Object, required: true })
    ], SessionSidebar.prototype, "strings", void 0);
    SessionSidebar = __decorate([
        Component
    ], SessionSidebar);
    return SessionSidebar;
}(Vue));
export default SessionSidebar;
